"use client";
import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { useAppSelector } from "../../_hooks/hooks";

const WhatsAppIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasNotification, setHasNotification] = useState(true);

  const WhatsAppNo = useAppSelector(
    (state) =>
      state.home.SettingList?.find((s: any) => s.SettingKey === "WhatsAppNo")
        ?.SettingValue,
  );

  const phone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappLink = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent("Hello, I'd like to know more details.")}`
    : "#";

  const handleIconClick = () => {
    setIsOpen(!isOpen);
    setHasNotification(false);
  };

  const handleCardClick = () => {
    if (whatsappLink !== "#") {
      window.open(whatsappLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      {/* WhatsApp Dialog Box */}
      <div
        className={`fixed bottom-28 md:bottom-20 right-4 z-[999] w-[320px] md:w-[350px] bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 transition-all duration-300 origin-bottom-right transform ${
          isOpen
            ? "scale-100 opacity-100 pointer-events-auto"
            : "scale-75 opacity-0 pointer-events-none"
        }`}
      >
        {/* Header */}
        <div className="bg-[#09D261] p-4 flex items-center justify-between text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center shadow-inner">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-sm md:text-base leading-tight tracking-wide">
                Statue of Unity
              </span>
              <span className="text-[10px] md:text-xs text-white/90">
                Welcome to Statue of Unity
              </span>
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(false);
            }}
            className="p-1 hover:bg-white/10 rounded-full transition-colors focus:outline-none"
            aria-label="Close chat dialog"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>

        {/* Body */}
        <div className="bg-[#f5f7f9] p-4">
          <div
            onClick={handleCardClick}
            className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md hover:bg-gray-50 transition-all duration-300 cursor-pointer flex items-center gap-3 group"
          >
            {/* Left green circular WhatsApp logo inside the card */}
            <div className="w-10 h-10 bg-[#25D366]/10 text-[#25D366] rounded-full flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform">
              <MessageCircle className="w-5 h-5" />
            </div>

            {/* Right Text Details */}
            <div className="flex flex-col min-w-0">
              <div className="flex items-center gap-1.5 text-[11px] text-green-500 font-semibold mb-0.5">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
                <span>Online</span>
              </div>
              <span className="font-bold text-gray-800 text-sm truncate">
                Statue Of Unity
              </span>
              <span className="text-[11px] text-gray-500 mt-0.5 font-medium truncate">
                Me I Help You !??
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleIconClick}
        className="fixed bottom-12 md:bottom-4 right-4 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 hover:shadow-green-500/50 group w-[60px] h-[60px] flex items-center justify-center focus:outline-none cursor-pointer"
        aria-label="Toggle WhatsApp Chat Dialog"
      >
        <MessageCircle className="w-7 h-7 group-hover:rotate-12 transition-transform" />

        {/* Notification Badge */}
        {hasNotification && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center text-[10px] font-bold border-2 border-white animate-pulse shadow-md">
            1
          </span>
        )}
      </button>
    </>
  );
};

export default WhatsAppIcon;
